import {WidgetFaqTerms} from "@/components/organisms/widget--faq-terms";
import FAQSection, {Section} from "components/shadcn/_custom/faq-section";
import {NO_FAQ_CATEGORIES_GROUP} from "@/lib/constants";
import {useContext} from "react";
import {Dictionary} from "@/types/hygiena-types";
import {DictionaryContext} from "@/context/dictionary-context";

export function ParagraphFAQ({paragraph, ...props}) {
  const t = useContext<Dictionary>(DictionaryContext);
  if (!paragraph?.faqs?.length) {
    return <></>;
  }
  const sections: Section[] = [];
  const otherSection: Section = {id: 'general', title: t.faq.no_category, subsections: []};

  for (const item of paragraph?.faqs) {
    const isOther = !item?.faqs?.filter(faq => faq?.faqs?.length > 0)?.length;
    // 2-tier.
    if (isOther) {
      otherSection.subsections.push({
        id: item.title,
        title: item.title !== NO_FAQ_CATEGORIES_GROUP ? item.title : '',
        faqs: item.faqs.map(faq => ({
          question: faq?.name,
          answer: faq?.description?.processed ?? "",
        }))
      });
    }
    // 3-tier.
    else {
      const section: Section = {
        id: item.title,
        title: item.title,
        subsections: item.faqs.map(faq => ({
          id: faq?.name,
          title: faq?.name,
          faqs: faq?.faqs.map(faq => ({
            question: faq?.name,
            answer: faq?.description?.processed ?? "",
          }))
        })),
      }
      sections.push(section);
    }
  }

  if (otherSection?.subsections?.length) {
    sections.push(otherSection);
  }

  return (
    <div className="paragraph--faq component-faq">
      <FAQSection data={{sections}} />
    </div>
  )
}